import { getProfessionalCampaigns } from './GetProfessionalCampaigns';
import { getPromoCodes } from './GetPromoCodes';
import { getPromoCode } from './GetPromoCode';
import { getPromoCodeReport } from './GetPromoCodeReport';
import { getPromoCodeTargetOffices } from './GetPromoCodeTargetOffices';
import { getOfficeDiscountHistory } from './GetOfficeDiscountHistory';
import { applyOfficePromoCode } from './ApplyOfficePromoCode';
import { removeOfficePromoCode } from './RemoveOfficePromoCode';

export const CampaignsService = {
  getProfessionalCampaigns,
  getPromoCodes,
  getPromoCode,
  getPromoCodeReport,
  getPromoCodeTargetOffices,
  getOfficeDiscountHistory,
  applyOfficePromoCode,
  removeOfficePromoCode,
};
